import Funnel from "@/pages/app/Funnel";
import OnboardingFunnelCard from "@/components/OnboardingFunnelCard";
import CrashCourseFunnelCard from "@/components/CrashCourseFunnelCard";
import StackRecipeFunnelCard from "@/components/StackRecipeFunnelCard";
import SeatReferralFunnelCard from "@/components/SeatReferralFunnelCard";
import CashBuyersFunnelCard from "@/components/CashBuyersFunnelCard";

// Admin Funnel = the legacy visitor→pay funnel + the new onboarding/activation
// breakdown + the 5-day crash-course → signup attribution funnel + the new
// Stack Recipe library conversion funnel + the Seat-Referral Champions board
// + the /cash-buyers paid-traffic A/B widget.
export default function AdminFunnel() {
  return (
    <>
      <Funnel />
      <div className="mt-8">
        <OnboardingFunnelCard days={30} />
      </div>
      <CashBuyersFunnelCard />
      <CrashCourseFunnelCard />
      <StackRecipeFunnelCard />
      <SeatReferralFunnelCard />
    </>
  );
}
